import { useState } from "react";
import { Link } from "react-router-dom";
import { movies } from "@/mocks/movies";
import { newsArticles } from "@/mocks/news";

export default function HeroSection() {
  const [showNotice, setShowNotice] = useState(false);
  const featured = movies.find((movie) => movie.featured) || movies[0];

  return (
    <section className="relative w-full overflow-hidden bg-primary-950">
      <div className="absolute inset-0">
        <img
          src={featured.hero || featured.cover}
          alt="色戒完整版无删减hd 高清电影主视觉"
          title="色戒完整版无删减hd 高清电影海报"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/95 via-primary-950/80 to-primary-950/35" />
        <div className="absolute inset-0 bg-gradient-to-t from-primary-950 via-transparent to-primary-950/40" />
      </div>

      <div className="relative mx-auto flex max-w-shell flex-col px-4 pb-14 pt-28 md:px-6 md:pb-20 md:pt-36">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <div className="animate-fade-up inline-flex flex-wrap items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1.5 backdrop-blur-sm">
              <span className="flex h-1.5 w-1.5 rounded-full bg-accent-400" />
              <span className="text-[11px] tracking-wide text-background-100">高清修复 · 完整版资料</span>
              <span className="text-[11px] text-background-300">|</span>
              <span className="text-[11px] text-background-200">剧情 · 演员 · 相关资讯</span>
            </div>

            <h1 className="animate-fade-up delay-1 mt-5 max-w-2xl font-heading text-[32px] font-black leading-[1.18] tracking-tight text-background-50 sm:text-[42px] lg:text-[52px]">
              色戒完整版无删减hd
              <span className="mt-3 block text-[15px] font-normal leading-relaxed text-background-200 sm:text-base">
                高清影视内容展示与资讯门户 · 从剧情到演员，一次看明白
              </span>
            </h1>

            <div className="animate-fade-up delay-2 mt-6 flex flex-wrap items-center gap-x-4 gap-y-2 text-[12px] text-background-200">
              <span className="flex items-center gap-1.5">
                <i className="ri-calendar-line text-accent-400" />
                {featured.year}
              </span>
              <span className="h-3 w-px bg-background-50/25" />
              <span>{featured.genres.join(" / ")}</span>
              <span className="h-3 w-px bg-background-50/25" />
              <span>{featured.duration}</span>
              <span className="h-3 w-px bg-background-50/25" />
              <span>导演 {featured.director}</span>
              <span className="flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 font-label text-[11px] font-semibold text-background-50">
                <i className="ri-star-fill text-[10px]" />
                {featured.rating.toFixed(1)}
              </span>
            </div>

            <p className="animate-fade-up delay-2 mt-5 max-w-xl text-sm leading-[1.85] text-background-200">
              {featured.summary}
            </p>

            <div className="animate-fade-up delay-3 mt-8 flex flex-wrap items-center gap-3">
              <button
                type="button"
                onClick={() => setShowNotice(true)}
                className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
              >
                <i className="ri-play-fill text-lg" />
                播放预告（演示）
              </button>
              <Link
                to={`/detail/${featured.id}`}
                className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/35 px-5 py-3 text-sm text-background-50 transition-colors hover:border-accent-400 hover:text-accent-300"
              >
                查看影片详情
                <i className="ri-arrow-right-line" />
              </Link>
            </div>

            <p className="animate-fade-up delay-3 mt-4 flex items-center gap-1.5 text-[11px] text-background-400">
              <i className="ri-information-line" />
              本站为影视资料展示站点，播放按钮仅作交互演示，不提供真实播放。
            </p>
          </div>

          <div className="hidden lg:col-span-5 lg:flex lg:justify-end">
            <div className="animate-fade-up delay-2 relative w-[240px]">
              <div className="absolute -inset-3 rounded-xl border border-background-50/15" />
              <div className="relative overflow-hidden rounded-lg border border-background-50/20">
                <img
                  src={featured.cover}
                  alt="色戒电影高清竖版海报"
                  title="色戒完整版无删减hd 高清修复海报"
                  className="aspect-[2/3] w-full object-top"
                />
              </div>
              <div className="mt-4 grid grid-cols-3 gap-2 text-center">
                {[
                  { value: `${movies.length}`, label: "影片资料" },
                  { value: `${newsArticles.length}`, label: "资讯文章" },
                  { value: "HD", label: "高清修复" },
                ].map((item) => (
                  <div key={item.label} className="rounded-md border border-background-50/15 py-2">
                    <p className="font-label text-sm font-semibold text-accent-400">{item.value}</p>
                    <p className="mt-0.5 text-[10px] text-background-300">{item.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {showNotice && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-primary-950/70 px-4 backdrop-blur-sm">
          <div className="animate-fade-in w-full max-w-md rounded-lg border border-background-300 bg-background-50 p-6">
            <div className="flex items-start justify-between">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                <i className="ri-film-line text-xl" />
              </span>
              <button
                type="button"
                onClick={() => setShowNotice(false)}
                aria-label="关闭提示"
                className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-md text-foreground-500 transition-colors hover:bg-background-200"
              >
                <i className="ri-close-line text-lg" />
              </button>
            </div>
            <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">演示提示</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              这是一个影视内容展示站点，页面中的播放按钮仅用于演示交互流程，本站不提供在线播放、下载或任何版权内容。
              你可以继续浏览影片资料、剧情介绍与演员信息。
            </p>
            <div className="mt-5 flex gap-3">
              <Link
                to={`/detail/${featured.id}`}
                className="flex-1 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-center text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                去看影片资料
              </Link>
              <button
                type="button"
                onClick={() => setShowNotice(false)}
                className="flex-1 cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm text-foreground-700 transition-colors hover:bg-background-100"
              >
                知道了
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}